import { component } from "picoapp";

export default component(async (node) => {
  const [{ default: KeenSlider }, { useDots, useFade, useNav }] =
    await Promise.all([
      import("keen-slider"),
      import("../lib/keen-slider"),
      import("keen-slider/keen-slider.min.css"),
    ]);

  const sliderContainer = node.querySelector(".slider");
  const navContainer = node.querySelector(".nav");
  const dotsContainer = node.querySelector(".dots");
  const navSlidesLength = navContainer.querySelectorAll(
    ".keen-slider__slide"
  ).length;

  const mainSlider = new KeenSlider(
    sliderContainer,
    {
      loop: true,
    },
    [useFade, useDots(dotsContainer)]
  );

  // eslint-disable-next-line no-new
  new KeenSlider(
    navContainer,
    {
      loop: true,
      drag: false,
      slides: { perView: 1, number: navSlidesLength },
      slideChanged: (s) => {
        s.slides.forEach((slide, index) => {
          slide.style.opacity = s.track.details.slides[index].portion;
        });
      },
      detailsChanged: (s) => {
        const width = s.size;
        s.slides.forEach((slide, index) => {
          slide.style.transform = `translate3d(-${width * index}px, 0px, 0px)`;
          slide.style.minWidth = width + "px";
          slide.style.maxWidth = width + "px";
          slide.style.opacity = s.track.details.slides[index].portion;
        });
      },
      breakpoints: {
        "(min-width: 750px)": {
          loop: false,
          slides: { number: 1, perView: navSlidesLength },
          slideChanged: () => null,
          detailsChanged: () => null,
        },
      },
    },
    [useNav(mainSlider)]
  );
});
